import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import Search from '../../components/Search';
import Table from '../../components/Table';

import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {
  getPCTransactionList,
  deletePCTransaction,
} from '../../axios/ProjectCostTransactionAxios';
import LoadingOverlay from '../../components/LoadingOverlay';

const InquiryList = () => {
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Inquiry' },
  ];

  const [projectTransaction, setProjectTransaction] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);
  const [screenLoading, setScreenLoading] = useState(false);

  const navigation = useNavigate();

  const fetchProjectCostTransactionList = async (keyword, page, limit) => {
    try {
      const result = await getPCTransactionList(keyword, page, limit);

      // Set data yang sudah dimodifikasi
      setProjectTransaction(result.data);
      setTotalPages(result.totalPages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProjectCostTransactionList(searchKeyword, currentPage, limit);
  }, [searchKeyword, currentPage, limit]);

  const handleSearch = (keyword) => {
    setSearchKeyword(keyword);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  const handleView = (id) => {
    navigation(`view/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
          denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
          cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            setScreenLoading(true);
            await deletePCTransaction(id);
            await fetchProjectCostTransactionList(
              searchKeyword,
              currentPage,
              limit
            );
            swalWithBootstrapButtons.fire({
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              icon: 'success',
            });
            setScreenLoading(false);
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
            });
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      setScreenLoading(false);
    }
  };

  const columnMap = {
    project: 'Project',
    location: 'Location',
    year: 'Year',
    poNo1: 'PO. No1',
    poNo2: 'PO. No2',
    total_cost: 'Total Cost',
  };

  return (
    <div>
      <LoadingOverlay
        show={screenLoading}
        message="Deleting transaction data..."
      />
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      <div className="card">
        <div className="card-body">
          <div className="table-search-new mb-2">
            <Search onSearch={handleSearch} />
            <div className=""></div>
          </div>
          <Table
            items={projectTransaction}
            columnMap={columnMap}
            isLoading={isLoading}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            limit={limit}
            onView={handleView}
            onDelete={handleDelete}
            showViewButton={false} // Tampilkan tombol "view"
            showEditButton={false} // Sembunyikan tombol "edit"
            showViewOnlyButton={true}
          />
        </div>
      </div>
    </div>
  );
};

export default InquiryList;
